import { Typography, Tabs, Tab, Box } from '@material-ui/core';
import { useState } from 'react';
import { SectionMenu } from './SectionMenu';

export const LinksPage = () => {
  const [tab, setTab] = useState(0);

  return (
    <Box style={{ width: '100%', padding: '24px 0' }}>
      <Typography variant="h4" style={{ textAlign: 'center', marginBottom: 16 }}>
        Links
      </Typography>
      <Tabs
        value={tab}
        onChange={(_, v) => setTab(v)}
        centered
        indicatorColor="primary"
        textColor="primary"
      >
        <Tab label="Hydra Tools" />
        <Tab label="OKD Consoles" />
      </Tabs>
      <Box style={{ marginTop: 24 }}>
        {tab === 0 && <SectionMenu section="Hydra Tools" />}
        {tab === 1 && <SectionMenu section="OKD Consoles" />}
      </Box>
    </Box>
  );
};
